import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SelectMultipleModule } from '../select-multiple/select-multiple.module';
import { ConfigClientMcfComponent } from './config-client-mcf.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    SelectMultipleModule,
  ],
  declarations: [
    ConfigClientMcfComponent,
  ],
  exports: [
    ConfigClientMcfComponent,
  ]
})

export class ConfigClientMcfModule { }
